import { IIconBase } from '..'

const boxImportNfIcon = ({
  color = '#04A782',
  height = 32,
  width = 43,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 43 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Group'>
        <path
          id='Vector'
          d='M42.0519 16.3372L32.9232 5.71694C32.7073 5.46358 32.4391 5.25952 32.1367 5.11868C31.8343 4.97785 31.505 4.90356 31.1711 4.90088H11.5423C10.869 4.90088 10.229 5.20833 9.79025 5.71694L0.661621 16.3372V22.1673H42.0519V16.3372Z'
          fill='url(#paint0_linear_6080_19943)'
        />
        <path
          id='Vector_2'
          d='M39.466 22.3819L31.4761 13.1319C31.283 12.9135 31.0449 12.739 30.7779 12.6203C30.511 12.5016 30.2215 12.4414 29.9291 12.4439H12.7859C12.1974 12.4439 11.6223 12.6868 11.2388 13.1319L3.24902 22.3819V27.4624H39.466V22.3819Z'
          fill='#E2EEE8'
        />
        <path
          id='Vector_3'
          d='M42.0518 28.8487C42.0518 29.6582 41.6856 30.386 41.1076 30.8737L40.9903 30.9686C40.532 31.3142 39.9725 31.5008 39.3975 31.5H3.31694C2.99075 31.5 2.67887 31.4412 2.39082 31.333L2.24776 31.2761C1.77576 31.0671 1.37474 30.7266 1.09324 30.2956C0.811736 29.8646 0.661816 29.3618 0.661621 28.8478V16.4009H10.704C11.8132 16.4009 12.7069 17.309 12.7069 18.4107V18.4249C12.7069 19.5276 13.6111 20.4167 14.7203 20.4167H27.9931C28.5263 20.4162 29.0376 20.2055 29.4149 19.8308C29.7923 19.456 30.0051 18.9478 30.0066 18.4173C30.0066 17.3109 30.9012 16.4009 32.0095 16.4009H42.0528L42.0518 28.8487Z'
          fill='url(#paint1_linear_6080_19943)'
        />
        <path
          id='Vector_4'
          d='M25.0986 11.4607L21.303 15.2563L17.5073 11.4607'
          stroke={color}
          strokeWidth='2.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          id='Vector_5'
          d='M21.3027 1.33878L21.3027 14.2061'
          stroke={color}
          strokeWidth='2.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_6080_19943'
          x1='21.3567'
          y1='4.90088'
          x2='21.3567'
          y2='12.6621'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#26A085' />
          <stop offset='1' stopColor='#00785D' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_6080_19943'
          x1='21.3572'
          y1='16.4009'
          x2='21.3572'
          y2='31.5'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#05AE88' />
          <stop offset='1' stopColor='#009977' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default boxImportNfIcon
